import React, { useEffect, useRef, useState } from "react";
import { Box, Button, TextField, Tooltip, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import Scrollbars from "react-custom-scrollbars";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  checkinDetailSelector,
  learningResponseModalSelector,
  learningResponseSelector,
} from "Recoil/Checkins/selector";
import { useCheckinDetails } from "Hooks/checkin/useCheckinDetails";
import { get } from "lodash";
import {
  learningResponseModalState,
  learningResponseState,
} from "Recoil/Checkins/atom";
import moment from "moment";
import { defaultAttachmentImage, getUserId } from "src/utils";
import { useToast } from "Hooks/useToast";
import ShowMoreButton from "Components/formControls/HookFields/DescriptionEllipsis";
import { CHARACTER_LIMIT_FOR_RESPONSE } from "Constants/index";
import { LoadingWidget } from "Components/index";
import NoCommentAdded from "./NoCommentAdded";

const ViewResponses = ({ handleClose }) => {
  const { submitLearningReview } = useCheckinDetails();
  const learningResponseData = useRecoilValue(learningResponseSelector);
  const selectedResponse = useRecoilValue(learningResponseModalSelector);
  const setSelectedResponse = useSetRecoilState(learningResponseModalState);
  const classes = useStyles();
  const setLearningResponseData = useSetRecoilState(learningResponseState);
  const [userList, setUserList] = useState([]);
  const [userResponse, setUserResponse] = useState({});
  const [comment, setComment] = useState("");
  const toaster = useToast();
  const checkinDetails = useRecoilValue(checkinDetailSelector);
  const [loader, setLoader] = useState(false);
  const scrollbarsRef = useRef();
  const isLeadReviwer =
    get(checkinDetails, "checkinCoach.id", "") === getUserId();

  const isAddedFromBE = checkinDetails?.allCheckinViewers
    ?.filter((res) => !res.isAddedFromBE)
    ?.find((res) => res.userid === getUserId());
  let defaultImage = "";
  const [selectedCount, setSelectCount] = useState(0);

  useEffect(() => {
    const [user] = learningResponseData?.filter(
      (item) => item.id === selectedResponse
    );
    if (get(user, "responseDocument.fileName", "")) {
      defaultImage = defaultAttachmentImage(
        get(user, "responseDocument.key", ""),
        get(user, "responseDocument", "")
      );
      setUserResponse({ ...user, defaultImage });
    } else if (get(user, "attachmentLink.0.link", "")) {
      defaultImage = defaultAttachmentImage(
        "",
        get(user, "attachmentLink.0.link", "")
      );
      setUserResponse({ ...user, defaultImage });
    } else {
      setUserResponse({ ...user });
    }
  }, [selectedResponse]);

  useEffect(() => {
    if (selectedResponse && selectedCount === 0) {
      const unSelecteduser = learningResponseData.filter(
        (item) => item.id !== selectedResponse
      );
      const [selectedUser] = learningResponseData.filter(
        (item) => item.id === selectedResponse
      );
      unSelecteduser.unshift(selectedUser);
      setUserList([...unSelecteduser]);
      const count = selectedCount + 1;
      setSelectCount(count);
    }
  }, [selectedResponse]);

  const handleSubmit = () => {
    if (isLeadReviwer) {
      setLoader(true);
      submitLearningReview({
        variables: {
          userId: get(userResponse, "id", ""),
          comment,
          checkinId: get(checkinDetails, "id", ""),
          commentedById: getUserId(),
        },
      })
        .then(() => {
          let result = learningResponseData.map((item) => {
            if (item.id === selectedResponse) {
              return {
                ...item,
                coachComment: comment,
              };
            } else {
              return { ...item };
            }
          });
          setLearningResponseData([...result]);
          toaster.success({ message: "Response added successfully" });
        })
        .catch((e) => {
          toaster.error({ message: "Something went wrong" });
        })
        .finally(() => {
          setLoader(false);
          handleClose();
        });
    }
  };
  return (
    <Box textAlign="left" p={3} className={classes.root}>
      <Box className={classes.userList}>
        <Scrollbars>
          <ul>
            {userList.map((item) => {
              return (
                <>
                  <li
                    onClick={() => {
                      setSelectedResponse(item.id);
                      scrollbarsRef?.current?.scrollTop();
                    }}
                  >
                    <Box
                      className={
                        item.id === selectedResponse
                          ? classes.selectedUser
                          : classes.allUsers
                      }
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <UserProfileWidget
                        firstName={item.firstName}
                        lastName={item.lastName}
                        url={item.profileImage}
                        status={item?.user?.status}
                      />
                    </Box>
                    <Tooltip
                      title={`${item.firstName} ${item.lastName} ${
                        item?.user?.status === "PENDING" ? " (Pending)" : ""
                      }`}
                    >
                      <Typography
                        variant="body2"
                        className="font-semibold font-13"
                        noWrap="true"
                      >
                        {get(item, "firstName", "")}{" "}
                        {get(item, "lastName", "").slice(0, 1)}.
                      </Typography>
                    </Tooltip>
                  </li>
                </>
              );
            })}
          </ul>
        </Scrollbars>
      </Box>
      <Box
        className={classes.content}
        border={1}
        borderColor="grey.300"
        ml={1}
        position="relative"
      >
        {get(userResponse, "usercomment") ? (
          <span className={classes.status}>
            Marked complete on{" "}
            {moment(get(userResponse, "updatedAt", "")).format("MM/DD/YYYY")}
          </span>
        ) : (
          ""
        )}

        <Box className={classes.responseContentWrapper} mt={2} pl={2} pr={1}>
          <Typography
            variant="body2"
            className="font-semibold"
            p={2}
            gutterBottom
          >
            Learning takeaways
          </Typography>
          <Box height="90%">
            <Scrollbars ref={scrollbarsRef}>
              <Box className={classes.responseContent} pr={1} height="100%">
                {get(userResponse, "responseDocument.fileName", "") ||
                userResponse?.attachmentLink?.[0]?.link ? (
                  <Box
                    className={classes.fileType}
                    textAlign="center"
                    p={1.5}
                    onClick={() =>
                      window.open(
                        userResponse?.attachmentLink?.[0]?.link
                          ? userResponse?.attachmentLink?.[0]?.link
                          : `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                              userResponse,
                              "responseDocument.key",
                              ""
                            )}`,
                        "_blank"
                      )
                    }
                  >
                    <img
                      className={`${classes.imagePosition}`}
                      src={get(
                        userResponse,
                        "defaultImage.selectedFileImage",
                        ""
                      )}
                      alt="file type"
                    />
                    <Tooltip
                      title={
                        get(userResponse, "responseDocument.fileName", "") ||
                        userResponse?.attachmentLink?.[0]?.link
                      }
                    >
                      <Typography
                        variant="body2"
                        className="font-12"
                        noWrap="true"
                      >
                        {get(userResponse, "responseDocument.fileName", "") ||
                          userResponse?.attachmentLink?.[0]?.link}
                      </Typography>
                    </Tooltip>
                  </Box>
                ) : (
                  ""
                )}

                {get(userResponse, "usercomment") ? (
                  <ShowMoreButton
                    description={get(userResponse, "usercomment", "")}
                    charLimit={CHARACTER_LIMIT_FOR_RESPONSE}
                  />
                ) : (
                  <Box pt={4} textAlign="center" width="100%" height="100%">
                    <NoCommentAdded />
                  </Box>
                  // <Box
                  //   className={classes.noComment}
                  //   width="100%"
                  //   textAlign="center"
                  // >
                  //   <NoComments />
                  //   <Typography variant="body2" className={`font-12`}>
                  //     No comments added
                  //   </Typography>
                  // </Box>
                )}
              </Box>
            </Scrollbars>
          </Box>
        </Box>
        <Box
          className={classes.reviewerComment}
          borderTop={1}
          borderColor="grey.300"
          mt={2}
          p={2}
        >
          <Typography variant="body2" className="font-semibold" gutterBottom>
            Reviewer comments
          </Typography>
          {get(userResponse, "coachComment", "") ? (
            <Box height="160px">
              <Scrollbars ref={scrollbarsRef}>
                <Box pr={1}>
                  <Typography variant="body2" className="font-13">
                    {get(userResponse, "coachComment", "")}
                  </Typography>
                  <Box display="flex" alignItems="center" mt={2}>
                    <UserProfileWidget
                      firstName={get(
                        checkinDetails,
                        "checkinCoach.firstName",
                        ""
                      )}
                      lastName={get(
                        checkinDetails,
                        "checkinCoach.lastName",
                        ""
                      ).slice(0, 1)}
                      url={get(
                        checkinDetails,
                        "checkinCoach.profileImage.fileName",
                        ""
                      )}
                    />
                    <Typography
                      variant="body2"
                      className="font-semibold font-13"
                      noWrap="true"
                    >
                      {get(checkinDetails, "checkinCoach.firstName", "")}{" "}
                      {get(checkinDetails, "checkinCoach.lastName", "").slice(
                        0,
                        1
                      )}
                      .
                    </Typography>
                  </Box>
                </Box>
              </Scrollbars>
            </Box>
          ) : !isAddedFromBE ? (
            <Box pt={8} textAlign="center" width="100%" height="100%">
              <NoCommentAdded />
            </Box>
          ) : (
            <Box className={classes.commentBox}>
              <TextField
                autoComplete="off"
                placeholder="Enter comments here"
                multiline
                disabled={
                  get(userResponse, "checkInStatus", "") !== "COMPLETE" ||
                  !isLeadReviwer
                }
                rows="7"
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                value={comment}
                variant="outlined"
                autofocus
                fullWidth={true}
                color="secondary"
                InputProps={{
                  classes: {
                    input: classes.inputBox,
                  },
                }}
              />
              <Box textAlign="right" mt={2}>
                <Button color="primary" className="mr10" onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  disabled={!comment.length || loader}
                  color="primary"
                  variant="contained"
                  data-testid="submit"
                  onClick={handleSubmit}
                >
                  {loader ? <LoadingWidget color="grey" /> : "Save"}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ViewResponses;
